<template>
    <div v-if="highlights && highlights.length" class="highlight-banner">
        <div class="container">
            <div class="highlight-container d-flex justify-content-center flex-wrap">
                <div
                    v-for="highlight in highlights"
                    :key="highlight"
                    class="highlight d-flex flex-md-fill justify-content-md-center"
                >
                    <h3>
                        <span>
                            <i class="fas fa-check"></i>
                        </span>

                        {{ highlight }}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        highlights: function () {
            return this.store.state.global.page.hero_key_features
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.highlight-banner {
    .highlight-container {
        margin-bottom: 40px;

        h3 {
            color: var(--wizard-step-header-color);
            font-size: rem(17px);

            @media screen and (min-width: $bp-medium) {
                font-size: rem(20px);
            }
        }

        span {
            color: var(--highlight-tick-color);
            margin-right: 5px;
        }

        .highlight {
            padding: 0 5px;

            @media screen and (min-width: $bp-medium) {
                padding: 0;
            }
        }
    }
}
</style>
